import React, { forwardRef, useImperativeHandle } from "react";
import { Snackbar } from "@mui/material";

 const ControlSnackbar = forwardRef((props, ref) => {
    const [timeLeft, setTimeLeft] = React.useState(process.env.REACT_APP_ALERT_TOAST_DEFAULT_TIME);
    const [informationMessageState, setInformationMessageState] = React.useState({
        informationMessageOpen: false,
        informationMessage: '',
    });
    const { informationMessageOpen, informationMessage } = informationMessageState;

    useImperativeHandle(ref, () => ({
        // 부모 컴포넌트에서 사용할 함수를 선언
        openMessage,
        openMessageLimit,
        closeMessage
    }));

    const openMessage = (message) => {  
        setInformationMessageState({
            informationMessageOpen: true,
            informationMessage: message,
        });
    };

    const openMessageLimit = (message, time) => {
        setInformationMessageState({
            informationMessageOpen: true,
            informationMessage: message,
        });
        setTimeLeft(time);
    };

    const closeMessage = () => {
        setInformationMessageState({
            ...informationMessageState, 
            informationMessageOpen: false
        });
    };

    const closeSnackbar = () => {
        setInformationMessageState({
            ...informationMessageState, 
            informationMessageOpen: false
        });
    };

    
    React.useEffect(() => {
        if (informationMessageOpen) {
            setTimeout(() => {
                closeSnackbar();
            }, timeLeft);
        }
    }, [informationMessageOpen]);


    return (
        <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={informationMessageOpen}
            onClose={closeSnackbar}
            onClick={closeSnackbar}
            message={informationMessage}
            key='topcenter' 
        />
    );
});

export default ControlSnackbar;